import { WorkflowsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function WorkflowFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <WorkflowsCommandList multiselect selected={selection} onSelect={onSelect} />
}
